/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-split': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.5 0h-6a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5H3v1.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5H7V.5a.5.5 0 0 0-.5-.5zM4 3.001h2.5c.014 0 .027 0 .04-.002H9v6H4V3.001zM6 2V1H1v6h2V2.5a.5.5 0 0 1 .5-.5H6z" _fill="#fff"/>'
  }
})
